<template>
  <v-container class="py-10" id="verantwortlichkeit">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#d62b03">Organisation</div>
        <h2>Verantwortlichkeit IT</h2>
        <p>
          Wer ist in den Organisationen für die IT verantwortlich? Unter den
          befragten Organisationen gaben nur <b>17%</b> an, hauptamtliche
          IT-Verantwortliche zu haben. Bei weiteren <b>19%</b> wird die IT
          hauptsächlich von einem externen Dienstleister übernommen. Bei den
          meisten Organisationen gibt es entweder keine verantwortliche Person
          (<b>24%</b>) oder sie ist ehrenamtlich engagiert (<b>41%</b>).
        </p>
        <p>
          In den 17% der Organisationen, in denen es hauptamtliche Mitarbeiter
          für die IT gibt, ist aber in <b>70%</b> der Fälle nur eine Stelle
          (oder weniger) eingeplant.
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'IT Verantwortlichkeit' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Verantwortlichkeit",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Wer ist in der Organisation für IT zuständig?"
        },
        xAxis: {
          categories: [
            "Eigene/r hauptamtliche/r Mitarbeiter",
            "Externer Dienstleister",
            "Eigene/r ehrenamtliche/r Mitarbeiter",
            "Es gibt keine hauptverantwortliche Person für IT"
          ],
          visible: true
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        colors: ["#d62b03", "#f06914", "#f0b414"],
        series: [
          {
            name: "genannt",
            data: [17.15, 18.58, 40.73, 2.3 + 21.24],
            showInLegend: false
          },
          {
            type: "pie",
            name: "Position IT-Verantwortliche",
            data: [
              {
                name: "eine Stelle oder weniger",
                y: 70
              },
              {
                name: "mehr als eine Stelle",
                y: 30
              }
            ],
            center: ["70%", "20%"],
            size: "25%",
            showInLegend: true,
            dataLabels: {
              enabled: false
            }
          }
        ],
        plotOptions: {
          series: {
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        legend: {
          align: "right"
        },
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "IT_Verantwortlichkeit",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
